export default __webpack_public_path__ + "static/media/github.61fc0153.png";